import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { listProducts } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Products() {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  useEffect(() => { listProducts().then(setProducts).catch(() => setProducts([])); }, []);

  return (
    <div data-testid="page-products" className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-24">
      <div className="tr-eyebrow">{t("products_page.eyebrow")}</div>
      <h1 className="tr-section-title text-5xl lg:text-7xl mt-4">{t("products_page.title_a")}<br />{t("products_page.title_b")}</h1>
      <p className="mt-6 max-w-2xl text-lg text-[var(--tr-muted)] leading-relaxed">{t("products_page.body")}</p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p) => (
          <Link key={p.id} to={`/products/${p.slug}`} data-testid={`products-card-${p.slug}`} className="tr-card overflow-hidden tr-nolink group">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={p.image_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--tr-zest)] font-bold">{p.category}</div>
              <div className="mt-2 font-display font-extrabold text-xl text-[var(--tr-deep-green)]">{p.name}</div>
              <p className="mt-3 text-sm text-[var(--tr-muted)] leading-relaxed line-clamp-3">{p.tagline || p.short_description}</p>
              <div className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[var(--tr-deep-green)]">
                {t("common.explore")} <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          </Link>
        ))}

        {[t("about.chip_veg"), t("about.chip_millets"), t("about.chip_pulses"), t("about.chip_spices")].map((c) => (
          <div key={c} className="rounded-3xl border border-dashed border-[rgba(6,78,59,0.25)] p-8 flex flex-col justify-between min-h-[280px] bg-white/50">
            <div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--tr-muted)] font-bold">{t("common.coming_soon")}</div>
              <div className="mt-2 font-display font-extrabold text-2xl text-[var(--tr-deep-green)]">{c}</div>
            </div>
            <p className="text-sm text-[var(--tr-muted)] leading-relaxed">{t("products_page.slot_note")}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
